import { render, staticRenderFns } from "./params-add.vue?vue&type=template&id=0209f6ba&"
import script from "./params-add.vue?vue&type=script&lang=ts&"
export * from "./params-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports